export enum StorePriceDisplayType {
    Dollars = 0,
    Points = 1,
    Both = 2,
}
